// payrollRulesApi.js
import api from '../api'; // Import your configured axios instance

// GET all payroll rules
export const getRules = async () => {
  try {
    const response = await api.get('/payroll/rules/');
    const rules = response.data;

    // Convert enum status to boolean isActive
    return rules.map(rule => ({
      ...rule,
      isActive: rule.status === 'ACTIVE'
    }));
  } catch (error) {
    console.error('Error fetching payroll rules:', error.response?.data || error.message);
    throw error;
  }
};

// GET payroll rules by context
export const getRulesByContext = async (context) => {
  try {
    const response = await api.get(`/payroll/rules/context/${context}`);
    const rules = response.data;

    // Convert enum status to boolean isActive
    return rules.map(rule => ({
      ...rule,
      isActive: rule.status === 'ACTIVE'
    }));
  } catch (error) {
    console.error('Error fetching rules by context:', error.response?.data || error.message);
    throw error;
  }
};

// POST new payroll rule
export const createRule = async (formData) => {
  try {
    const payload = {
      ...formData,
      status: formData.isActive ? 'ACTIVE' : 'INACTIVE',
    };
    delete payload.isActive;
    
    const response = await api.post('/payroll/rules/add', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating payroll rule:', error.response?.data || error.message);
    throw error;
  }
};

// DELETE payroll rule
export const deleteRule = async (id) => {
  try {
    const response = await api.delete(`/payroll/rules/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting payroll rule:', error.response?.data || error.message);
    throw error;
  }
};

// PUT update payroll rule
export const updateRule = async (id, formData) => {
  try {
    const payload = {
      ...formData,
      status: formData.isActive ? 'ACTIVE' : 'INACTIVE',
    };
    delete payload.isActive;
    
    const response = await api.put(`/payroll/rules/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating payroll rule:', error.response?.data || error.message);
    throw error;
  }
};